if (!customElements.get('shop-the-look-modal')) {
	customElements.define(
		'shop-the-look-modal',
		class ShopTheLookModal extends HTMLElement {
			constructor() {
				super();
				this.dialog = this.querySelector('.stl-modal__dialog');
				this.onBodyKeyup = this.onBodyKeyup.bind(this);

				// Fermeture : overlay, croix, tout élément [data-stl-close]
				this.querySelectorAll('[data-stl-close]').forEach((el) =>
					el.addEventListener('click', () => this.close())
				);

				// Mise à jour prix + libellé de variante au changement de select
				this.querySelectorAll('select[name="id"]').forEach((select) =>
					select.addEventListener('change', (e) => this.onVariantChange(e.target))
				);
			}

			open() {
				this.setAttribute('open', '');
				document.body.classList.add('overflow-hidden');
				if (this.dataset.breakpoint) {
					document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
				}
				document.addEventListener('keyup', this.onBodyKeyup);

				// trapFocus est un global du thème (global.js)
				if (typeof trapFocus === 'function') {
					trapFocus(this.dialog);
				} else {
					this.dialog.focus();
				}
			}

			close() {
				this.removeAttribute('open');
				document.body.classList.remove('overflow-hidden');
				if (this.dataset.breakpoint) {
					document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
				}
				document.removeEventListener('keyup', this.onBodyKeyup);

				if (typeof removeTrapFocus === 'function') {
					removeTrapFocus(this.trigger || null);
				}
			}

			onBodyKeyup(event) {
				if (event.code === 'Escape' || event.key === 'Escape') this.close();
			}

			onVariantChange(select) {
				const option = select.options[select.selectedIndex];
				const card = select.closest('.stl-card');
				if (!card) return;

				const priceEl = card.querySelector('[data-stl-price]');
				if (priceEl && option.dataset.price) priceEl.textContent = option.dataset.price;

				const nameEl = card.querySelector('[data-stl-variant-name]');
				if (nameEl && option.dataset.variantName) nameEl.textContent = option.dataset.variantName;
			}
		}
	);
}

// Ouverture depuis un bouton externe placé n'importe où (ex. au-dessus de la galerie).
// Le bouton doit porter l'attribut data-shop-the-look-trigger.
document.addEventListener('click', (event) => {
	const trigger = event.target.closest('[data-shop-the-look-trigger]');
	if (!trigger) return;

	event.preventDefault();
	const modal = document.querySelector('shop-the-look-modal');
	if (!modal) return;

	modal.trigger = trigger;
	modal.open();
});

// Si aucune modale sur la page (metafield vide), on masque les déclencheurs
// pour éviter un bouton mort.
document.addEventListener('DOMContentLoaded', () => {
	if (document.querySelector('shop-the-look-modal')) return;
	document
		.querySelectorAll('[data-shop-the-look-trigger]')
		.forEach((el) => (el.hidden = true));
});
